export default class Address {
  street: string = "";
  city: string = "";
  region: string = "";
  country: string = "";
}
